var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "cb96e797fc2ea56259a51a623844be94.png",
    width: 80,
    height: 80
});